module.exports = __webpack_public_path__ + "static/media/secure-packaging-and-world-wide-shipping-of-vintage-design-furniture-at-zo-goed-als-oud.b2f8e173.jpg";